<template>
  <div class="order-submit">
    <Button
      theme="primary order-submit-button"
      :disabled="disabled"
      :loading="orderSubmitting"
      @click="submitOrder"
    >
      {{ submitBtnText }}
      <BtnCornerTag v-if="isVirtual" :tag-name="$t('settings.virtual-tag')" />
    </Button>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Icon from 'com/Icon'
import Button from 'com/Button'
import orderValidateMixin from 'mixins/orderValidateMixin'
import stockMixin from 'mixins/stockMixin'
import BtnCornerTag from 'mod/BtnCornerTag'
import { SEC_TYPE } from 'const/stock'
import { ORDER_TYPE } from 'const/trade'

export default {
  components: {
    BtnCornerTag,
    Button,
    Icon
  },
  mixins: [orderValidateMixin, stockMixin],
  data() {
    return {
      showTradeWarning: false,
      shortQuantity: 0,
      hasHolding: false,
      aStockSalable: 0
    }
  },
  props: {
    positionNum: Number,
    orderSubmitting: Boolean
  },
  computed: {
    ...mapGetters([
      'hasModifyOrderRequest',
      'tradeRequest',
      'language',
      'isIb',
      'isVirtual',
      'isCash',
      'asset'
    ]),
    stock() {
      return this.tradeRequest.stock
    },
    order() {
      return this.tradeRequest.order
    },
    disabled() {
      if (this.isLMT) {
        return (
          !Number(this.order.limitPrice) || !Number(this.order.totalQuantity)
        )
      }
      return !Number(this.order.totalQuantity)
    },
    contract() {
      return this.tradeRequest.contract || {}
    },
    submitBtnText() {
      return this.hasModifyOrderRequest
        ? this.$t('trade.order-modify')
        : this.$t('trade.submit-order')
    },
    stockMark() {
      return this.stock.secType === SEC_TYPE.OPT
        ? this.stock.webLocal.symbol
        : this.stock.symbol
    },
    isMKT() {
      return this.order.orderType === ORDER_TYPE.MKT
    },
    isLMT() {
      return [ORDER_TYPE.LMT, ORDER_TYPE.STP_LMT].includes(this.order.orderType)
    }
  },
  methods: {
    submitOrder() {
      this.validateOrder(() => {
        this.$emit('submit')
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import '~uikit';
.order-submit {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
}
.order-submit-button {
  position: relative;
  min-width: 80px;
}
</style>
<style lang="less">
.trade-warning-modal {
  .highlight {
    color: var(--active-color);
  }
  .paragraph {
    margin-top: 10px;
    &:first-child {
      margin-top: 0;
    }
  }
}
</style>
